import React from 'react';
// ------------------------------------------------------------------
// MUI Imports as requested by the user
import { Box, Grid, Typography, Button } from '@mui/material'; 
// ------------------------------------------------------------------
import HeroImage from 'assets/images/pexels-jeshoots-com-147458-714701.jpg';
import { useT } from "contexts/TranslationContext";
// Custom color derived from the image for precise matching
const PRIMARY_GREEN = '#34986C'; 


const Hero = () => {
  const t = useT();

  return (
    <>
    {/* // Outer container using MUI Box, replacing the min-h-screen div */}
    <Box
      sx={{
        // minHeight: '100vh',
        bgcolor: 'white', // Background color
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Responsive padding (xs: 4 units, sm: 8 units, lg: 16 units)
        p: { xs: 4, sm: 8, lg: 16 }, 
        py: { xs: 2, sm: 4, lg: 8 }, // Vertical padding
        fontFamily: 'Inter, sans-serif' // Applying the required font
      }}
    >
      
      {/* Content wrapper using Grid container for layout */}
      <Grid 
        container 
        maxWidth="lg" // Equivalent to max-w-6xl
        spacing={{ xs: 6, lg: 12 }} // Responsive gap between columns
        alignItems="flex-start" // Align content to the top
      >
        
        {/* Left Column: Headline */}
        <Grid item xs={12} lg={6}>
          <Typography 
            variant="h2" // Large size, adjusting from Tailwind's 6xl
            component="h1" 
            sx={{
              fontWeight: 800, // Extrabold
              color: 'grey.900', // Text color
              lineHeight: '1.2', // Tight leading
              fontSize: { 
                xs: '2.5rem', // 40px on mobile
                sm: '3.5rem', // 56px on tablet
                lg: '4rem'   // 64px on desktop
              },
            }}
          >
            {t('hero.title')}
          </Typography>
        </Grid>
        
        {/* Right Column: Description and Button */}
        <Grid item xs={12} lg={6}>
          {/* Box to wrap description and button and maintain column stacking */}
          <Box 
            display="flex" 
            flexDirection="column" 
            alignItems="flex-start" 
            // Slight top padding for visual alignment with the headline
            pt={{ xs: 0, lg: '0.625rem' }} 
          >
            
            {/* Description Text */}
            <Typography 
              variant="body1" 
              sx={{ 
                color: 'grey.700', // Slightly muted gray body text
                fontSize: { xs: '1rem', sm: '1.125rem' },
                mb: 4, // Margin bottom
                maxWidth: '500px' // Max width for line length
              }}
            >
              {t('hero.subtitle')}
            </Typography>
            
            {/* Action Button */}
            <Button
              variant="contained"
              size="large"
              href="#features"
              sx={{
                bgcolor: PRIMARY_GREEN,
                '&:hover': {
                  bgcolor: '#2d845e', // Darker green on hover
                  transform: 'scale(1.01)',
                  boxShadow: 3,
                },
                px: 3, // Padding horizontal
                py: 1.5, // Padding vertical
                borderRadius: '8px', // Rounded corners
                fontWeight: 600, // Semibold
                textTransform: 'none', // Prevent uppercase
                boxShadow: 2, // Shadow
                transition: 'all 300ms ease', // Transition effect
              }}
              aria-label="Explore features"
            >
              {t('hero.explore')}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>

    {/* 2. Cover Image Section */}
    <Box
      maxWidth="lg" // Match the width of the content above
      width="100%"
      sx={{
          // The image in the provided design seems to be full-width of the container, 
          // but slightly rounded, so we will apply a border-radius here.
          borderRadius: '16px', 
          overflow: 'hidden', // Ensures image adheres to border radius
          boxShadow: 3, // Optional subtle shadow for depth
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          m: { xs: 4, sm: 8, lg: 16 }, 
          my: { xs: 1, sm: 2, lg: 4 }, // Vertical padding
      }}
    >
      <Box
          component="img"
          src={HeroImage}
          alt="Time and project management overview"
          sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: 'auto',
              // display: 'block',
              objectFit: 'cover',
              // Fallback style in case the image fails to load
              minHeight: { xs: '150px', sm: '300px' }, 
          }}
          // You can replace IMAGE_URL with your actual image path later
      />
    </Box>
    </>
  );
};
export default Hero;